'use client';

import dynamic from 'next/dynamic';

export const SearchBar = dynamic(() =>
  import('./SearchBar').then((m) => m.SearchBar)
);
